<script setup lang="ts">
import {onMounted} from 'vue';
import {RouterView} from 'vue-router';

import NavigationProgressBar from '@/shared/components/NavigationProgressBar.vue';
import useAuth from '@/shared/composables/useAuth';
import {useAppErrorStore} from '@/shared/stores/appError.store';
import ErrorLoadFailedView from '@/shared/views/Errors/ErrorLoadFailedView.vue';

const {checkUser} = useAuth();
const appErrorStore = useAppErrorStore();

onMounted(() => {
   checkUser();
});
</script>

<template>
   <NavigationProgressBar />
   <ErrorLoadFailedView v-if="appErrorStore.loadFailed" />
   <RouterView v-else />
</template>
